<template>
  <div class="div-do-background">
    <div class="container-do-texto-do-background">
      <!-- tem sempre que deixar um espaço depois da ultima letra se não corta um pedacooo -->
      <p class="texto-no-background">ALUNOS</p>
    </div>

    <div class="flip-card">
      <div class="flip-card-inner">
        <div class="flip-card-front container-geral ">
          <div style="margin-top: 25%;">
            <!-- esse é o cubo que gira pra usar pra fazer o loading -->
            <div class="cube">
              <div class="top"></div>
              <div class="right"></div>
              <div class="bottom"></div>
              <div class="left"></div>
              <div class="front"></div>
              <div class="back"></div>
            </div>
          </div>
          <p style="color: #7f6f94; margin-top: 90px; ">
            <i>.. carregando dados ..</i>
          </p>
        </div>

        <div class="flip-card-back container-geral ">
          <!-- ######################################## -->
          <!-- row da barra superior contendo marca e tab bar. -->
          <!-- ######################################## -->
          <v-row justify-space-between no-gutters>
            <!-- esse v-col cria a margem esquerda da barra superior em branco-->
            <v-col col="2" class="text-center"> </v-col>

            <!-- esse v-col com position:absolute é onde resalmente está a marca do cem  -->
            <v-col
              col="2"
              class="text-center"
              style="height: 100%; position: absolute;"
            >
              <img
                src="../assets/logo_simbolo_semfundo.png"
                class="logo-do-container-geral"
              />
            </v-col>

            <v-col col="10">
              <v-tabs class="tabs-container-geral" show-arrows justify-self-top>
                <v-tab class="tabeeee">Alunos</v-tab>
                <v-tab class="tabeeee">Professores</v-tab>
                <v-tab>Matérias</v-tab>
                <v-tab>Salas</v-tab>
                <div class="spacer"></div>
                <span class="v-tooltip v-tooltip--bottom"></span>
                <v-tab><v-icon right>mdi-settings</v-icon></v-tab>
              </v-tabs>
            </v-col>
          </v-row>
          <!-- fim da barra superior -->

          <!-- ######################################## -->
          <!-- Chinêees ESSA é a div do conteudooooooo. O CONTEÚDO vai aquiiiiiii -->
          <!-- ######################################## -->
          <v-row justify-center no-gutters style="height: 100%;">
            <v-col col="8" class="div-do-conteudo" justify-center>
              <v-data-table
                style="margin: 30px auto 0; background-color: rgba(0,0,0,0); box-shadow: none !important; max-width: 500px;"
                dense
                :headers="headers"
                :items="desserts"
                item-key="name"
                class="elevation-1"
                :search="search"
                :custom-filter="filterOnlyCapsText"
              >
                <template v-slot:top style="width: 300px;">
                  <v-text-field
                    v-model="search"
                    label="Buscar aluno"
                    class=""
                    style="width: 300px;"
                  ></v-text-field>
                  <!-- <div class="" style="display: inline;">
                    <v-btn depressed small color="primary">Primary</v-btn>
                  </div> -->
                </template>

                <template v-slot:body.append>
                  <tr>
                    <td>Thiago Lucio</td>
                    <td>32</td>
                    <td>Supletivo</td>
                    <td colspan="4"></td>
                  </tr>
                  <tr>
                    <td>Thiago Lucio</td>
                    <td>32</td>
                    <td>Supletivo</td>
                    <td colspan="4"></td>
                  </tr>
                  <tr>
                    <td>Thiago Lucio</td>
                    <td>32</td>
                    <td>Supletivo</td>
                    <td colspan="4"></td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>

          <v-row row no-gutters justify-center style="height: 60px;">
            <v-col col="8" class="div-do-rodape"> </v-col>
          </v-row>
        </div>
      </div>
      <!-- fechamento do card back -->
    </div>
    <!-- fechamento do card inner -->
  </div>
</template>

<!-- <h1>
  Admin
</h1>
<p>
  <strong>Cadastrar nova matéria</strong>
  <v-btn small @click="createSubjectDialog = true" fab to="admin">
    <v-icon>mdi-plus</v-icon>
  </v-btn>
</p>
<v-divider></v-divider>
<p>
  <strong>Cadastrar aulas</strong>
  <v-btn small @click="createClassDialog = true" fab>
    <v-icon>mdi-plus</v-icon>
  </v-btn>
</p>
<CreateClassDialog
:subjects="subjects"
@positive="onCreateClassClick"
:visibility="createClassDialog"
@negative="createClassDialog = false"
/>
<CreateSubjectDialog
@positive="onCreateSubjectClick"
:visibility="createSubjectDialog"
@negative="createSubjectDialog = false"
/> -->

<script>
import CreateClassDialog from "@/components/dialogs/CreateClassDialog";
import CreateSubjectDialog from "@/components/dialogs/CreateSubjectDialog";

import ClassroomRepository from "@/repositories/ClassroomRepository";

export default {
  components: {
    CreateClassDialog,
    CreateSubjectDialog
  },
  data() {
    return {
      createSubjectDialog: false,
      createClassDialog: false,
      subjects: []
    };
  },
  mounted() {
    this.listSubjects();
  },
  methods: {
    async onCreateSubjectClick(form) {
      const response = await ClassroomRepository.createSubject(form);

      this.createSubjectDialog = false;
    },
    async listSubjects() {
      const response = await ClassroomRepository.listSubjects();

      this.subjects = response.data;
    },
    async onCreateClassClick(form) {
      const response = await ClassroomRepository.createClassSubject(form);

      this.createClassDialog = false;
    }
  }
};
</script>

<style scoped>
/* @import url("https://fonts.googleapis.com/css?family=Montserrat:400,900&display=swap"); */
.div-do-background {
  padding: 3% 6% 4%;
  background-color: rgba(253, 253, 254, 1);
  background-color: -moz-linear-gradient(
    -45deg,
    rgba(253, 253, 254, 1) 0%,
    rgba(250, 250, 251, 1) 100%
  );
  background-color: -webkit-linear-gradient(
    -45deg,
    rgba(253, 253, 254, 1) 0%,
    rgba(250, 250, 251, 1) 100%
  );
  background-color: -o-linear-gradient(
    -45deg,
    rgba(253, 253, 254, 1) 0%,
    rgba(250, 250, 251, 1) 100%
  );
  background-color: -ms-linear-gradient(
    -45deg,
    rgba(253, 253, 254, 1) 0%,
    rgba(250, 250, 251, 1) 100%
  );
  background-color: linear-gradient(
    135deg,
    rgba(253, 253, 254, 1) 0%,
    rgba(250, 250, 251, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fdfdfe', endColorstr='#fafafb', GradientType=1 );
  background-image: url("../assets/bolinhas.svg");
  background-size: 300px;
  background-repeat: no-repeat;
  background-position: 2% 150%;
  overflow: hidden;
}
.container-do-texto-do-background {
  position: absolute;
  top: -60px;
  right: -12px;
}
.texto-no-background {
  font-size: 150px;
  line-height: 1;
  /* font-family: "Montserrat", sans-serif; */
  font-family: 'Poppins', sans-serif;
  font-weight: 900;
  height: 300px;
  letter-spacing: -35px;
  color: rgba(0, 0, 0, 0.03);
  -webkit-writing-mode: vertical-lr;
  -ms-writing-mode: tb-lr;
  writing-mode: vertical-lr;
  text-orientation: upright;
}
.container-geral {
  height: 100%;
  width: 100%;
  padding: 0 12px 12px;
  position: relative;
  display: flex;
  flex-direction: column;
  background: rgba(253, 253, 254, 0.5);
  background: -moz-linear-gradient(
    -45deg,
    rgba(253, 253, 254, 1) 0%,
    rgba(250, 250, 251, 1) 100%
  );
  background: -webkit-linear-gradient(
    -45deg,
    rgba(253, 253, 254, 1) 0%,
    rgba(250, 250, 251, 1) 100%
  );
  background: -o-linear-gradient(
    -45deg,
    rgba(253, 253, 254, 1) 0%,
    rgba(250, 250, 251, 1) 100%
  );
  background: -ms-linear-gradient(
    -45deg,
    rgba(253, 253, 254, 1) 0%,
    rgba(250, 250, 251, 1) 100%
  );
  background: linear-gradient(
    135deg,
    rgba(253, 253, 254, 1) 0%,
    rgba(250, 250, 251, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fdfdfe', endColorstr='#fafafb', GradientType=1 );
  box-shadow: 0 3px 60px 20px rgba(10, 5, 20, 0.1),
    0 45px 25px -30px rgba(15, 5, 15, 0.15);
}
.logo-do-container-geral {
  max-width: 100%;
  min-width: 0px;
  min-width: 0px;
  max-width: 102px;
  margin: 0 auto;
  padding-top: 18px;
  transform: 0.3s;
}
.div-do-conteudo {
  border-top: 2px solid #440099;
}
.div-do-rodape {
  border-top: 2px solid #440099;
}

.flip-card {
  background-color: transparent;
  height: 100%;
  width: 100%;
  padding: 0 12px 12px;
  position: relative;
  perspective: 1000px;
}
.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 2s;
  transform-style: preserve-3d;
}
.flip-card:hover .flip-card-inner {
  transform: rotateX(180deg);
}
.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}
.flip-card-front {
  background-color: #44ff99;
  color: black;
}
.flip-card-back {
  background-color: #2980b9;
  color: white;
  transform: rotateX(180deg);
}
</style>
